// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Footer() {
    const { year } = { year: new Date().getFullYear() };
    
    return (
   <div className="container-fluid footer bg-dark wow fadeIn" data-wow-delay=".3s" style={{visibility: "visible", animationDelay: "0.3s", animationName: "fadeIn"}}>
            <div className="container pt-5 pb-4">
                <div className="row g-5 m-1">
                    <div className="col-lg-3 col-md-6">
                        <a href="/">
                            <h1 className="text-white fw-bold d-block">UNIGENIUS<span className="text-secondary"></span> </h1>
                        </a>
                        <p className="mt-4 text-light">Unigenius empowers students with expert guidance to secure the right university and course in the UK.</p>
                        <div className="d-flex hightech-link">
                            <a href="https://www.facebook.com/people/Unigenius-Consultants/61578838221328" className="btn-light nav-fill btn btn-square rounded-circle me-2"><i className="fab fa-facebook-f text-primary"></i></a>
                            <a href="https://www.tiktok.com/@unigeniusuk?_r=1&_t=ZN-93L2ekKkjHX" className="btn-light nav-fill btn btn-square rounded-circle me-2"><i className="fab fa-tiktok text-primary"></i></a>
                            <a href="https://www.instagram.com/unigeniusuk/" className="btn-light nav-fill btn btn-square rounded-circle me-2"><i className="fab fa-instagram text-primary"></i></a>
                            <a href="https://www.linkedin.com/company/unigenius/" className="btn-light nav-fill btn btn-square rounded-circle me-0"><i className="fab fa-linkedin-in text-primary"></i></a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <a href="#" className="h3 text-white">Quick Link</a>
                        <div className="mt-4 d-flex flex-column short-link">
                            <NavLink className="mb-2 text-white" to="about"><i className="fas fa-angle-right text-secondary me-2"></i>About us</NavLink>
                            <NavLink className="mb-2 text-white" to="contact"><i className="fas fa-angle-right text-secondary me-2"></i>Contact us</NavLink>
                            <NavLink className="mb-2 text-white" to="courses"><i className="fas fa-angle-right text-secondary me-2"></i>Courses</NavLink>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <a href="#" className="h3 text-white">Help Link</a>
                        <div className="mt-4 d-flex flex-column help-link">
                            <NavLink to="privacy-policy" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Privacy Policy</NavLink>
                            <NavLink to="contact" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Contact</NavLink>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <a href="#" className="h3 text-white">Contact Us</a>
                        <div className="text-white mt-4 d-flex flex-column contact-link">
                            <a href="#" className="pb-3 text-light border-bottom border-primary"><i className="fas fa-map-marker-alt text-secondary me-2"></i>205 Kings Road, Tyseley, Birmingham</a>
                            <a href="#" className="py-3 text-light border-bottom border-primary"><i className="fas fa-phone-alt text-secondary me-2"></i>+441214920555</a>
                            <a href="#" className="py-3 text-light border-bottom border-primary"><i className="fas fa-envelope text-secondary me-2"></i>info@unigenius.uk</a>
                        </div>
                    </div>
                </div>
                <hr className="text-light mt-5 mb-4" />
                <div className="row">
                    <div className="col-md-12 text-md-start">
                        <span className="text-light"><a href="#" className="text-secondary"><i className="fas fa-copyright text-secondary me-2"></i> {year} UNIGENIUS</a>, Company number: 14906685. All right reserved.</span>
                    </div>
                    {/* <div className="col-md-6 text-center text-md-end">
                        <span className="text-light">Designed By<a href="https://htmlcodex.com" className="text-secondary">HTML Codex</a> Distributed By <a href="https://themewagon.com">ThemeWagon</a></span>
                    </div> */}
                </div>
            </div>
        </div>
 
  );
}
